import React from "react";
import ReactDOM from "react-dom";
import UserProvider from "../../providers/UserProvider";
import ProfileShell from "../../components/ProfileShell";

const parseTabs = serializedTabs => {
  try {
    return JSON.parse(serializedTabs || "[]");
  } catch (_error) {
    return [];
  }
};

const renderProfileShell = container => {
  const { userSlug, site = "us", activeTab, tabs, userData } = container.dataset;

  ReactDOM.render(
    <UserProvider site={site} userSlug={userSlug}>
      <ProfileShell activeTab={activeTab} tabs={parseTabs(tabs)} userData={userData} />
    </UserProvider>,
    container
  );
};

document.addEventListener("DOMContentLoaded", function () {
  const shellContainer = document.getElementById("myad-profile-shell-component");
  if (!shellContainer) { return; }

  renderProfileShell(shellContainer);
});
